window.addEventListener('load', () => {
    let nodesArray=[]
    let upsellItems = document.querySelector(".single-upsell-container")
    if(upsellItems){
        nodesArray = Array.from(upsellItems.children);
    }
    let upsellCollection = document.querySelector(".upsell-collection")
    let upsell = new ProductUpsell()

    for (let i = 0; i < nodesArray.length; i++) {
        let currentProduct = nodesArray[i]
        if (!upsell.checkInCart(currentProduct)) {
            break;
        } else if (upsell.checkInCart(currentProduct)) {
            currentProduct.style.display = "none";
            upsellItems.children[upsell.nextSingleUpsell(i)].style.display = 'flex'
        }
    }
    nodesArray.forEach((node, index) => {
        if (upsell.checkInCart(node)) {
            upsellCollection.children[index].style.display = "none";
        }
    })
});

class ProductUpsell extends HTMLElement {
    constructor() {
        super();
        this.upsellItems = document.querySelector(".single-upsell-container")
        if (this.upsellItems) {
            this.nodes = Array.prototype.slice.call(this.upsellItems.children)
        }
        this.upsellCollection = document.querySelector(".upsell-collection")
    }


    getProductIndex() {
        for (let [i, upsellItem] of this.nodes.entries()) {
            if (upsellItem.style.display === 'flex') {
                return i;
            }
        }
        return -1;
    }

    checkInCart(product) {
        let cartItems = Array.from(document.querySelector(".cart--body").children)
        return !!cartItems.find(i => i.dataset.productId === product.dataset.productId)
    }

    nextSingleUpsell(currentIndex) {
        if (!this.checkInCart(this.nodes[currentIndex + 1])) {
            return currentIndex + 1

        } else {
            return this.nextSingleUpsell(currentIndex + 1)
        }
    }

    checkUpsellRemoved(product) {
        let firstIndex = 0;
        for (let [index, upsellItem] of this.nodes.entries()) {
            if (parseInt(upsellItem.dataset.productId) === product.id) {
                firstIndex = this.getProductIndex();
                if (firstIndex < 0) {
                    upsellItem.style.display = "flex"
                } else if (index < firstIndex) {
                    upsellItem.style.display = "flex"
                    this.nodes[firstIndex].style.display = "none"
                }
                this.upsellCollection.children[index].style.display = "block"
                break
            }
        }
    }

    checkUpsellAdded(product) {
        let firstIndex = 0;
        for (let [index, upsellItem] of this.nodes.entries()) {
            if (product.id === parseInt(upsellItem.dataset.productId)) {
                firstIndex = this.getProductIndex()
                upsellItem.style.display = "none";
                this.upsellCollection.children[index].style.display = "none";
                if (index > firstIndex) {
                    this.nodes[firstIndex].style.display = 'flex'
                } else {
                    this.nodes[this.nextSingleUpsell(index)].style.display = 'flex'
                }

            }
        }
    }

}

customElements.define("product-upsell", ProductUpsell);

